import axiosInstance from "../../../api/axiosInstance";

export const fetchGrammarTopics = async (params) => {
  try {
    const cleaned = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v != null)
    );
    console.log("[GrammarService] Fetching topics, params:", cleaned);
    const res = await axiosInstance.get("/public/grammar-topic", { params: cleaned });
    console.log("[GrammarService] Fetch topics response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[GrammarService] Fetch topics failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchGrammarTopicById = async (id) => {
  try {
    console.log("[GrammarService] Fetching topic by id:", id);
    const res = await axiosInstance.get(`/public/grammar-topic/${id}`);
    console.log("[GrammarService] Fetch topic by id response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[GrammarService] Fetch topic by id failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchGrammarSubTopicById = async (id) => {
  try {
    console.log("[GrammarService] Fetching sub-topic by id:", id);
    const res = await axiosInstance.get(`/public/grammar-topic/sub-topic/${id}`);
    console.log("[GrammarService] Fetch sub-topic by id response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[GrammarService] Fetch sub-topic by id failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed to fetch" };
  }
};
